import React, { useEffect } from 'react';
import { Routes, Route, useParams, useNavigate } from 'react-router-dom';
import { Container, CssBaseline, CircularProgress } from '@mui/material';
import { GroupsPage, PlatesPage, SetupPage, HomePage, PointsPage, OriginsPage, CheckPointsPage, EventsPage, CustomersPage, StatisticReportPage, ReactionsPage } from './pages';
import {ResponsiveDrawer} from './components/drawer/ResponsiveDrawer2';
import HomeIcon from "@mui/icons-material/Home";
import PlaceIcon from "@mui/icons-material/Place";
import GroupIcon from "@mui/icons-material/Group";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import SettingsIcon from "@mui/icons-material/Settings";
import PeopleIcon from "@mui/icons-material/People";
import VideocamIcon from '@mui/icons-material/Videocam';
import RouteIcon from '@mui/icons-material/Route';
import HistoryIcon from '@mui/icons-material/History';
import LogoutIcon from '@mui/icons-material/Logout';
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import { AccountTree, CorporateFare, Payment, SettingsApplications } from "@mui/icons-material";
import { useTranslation } from 'react-i18next';
import LogoutPage from './components/auth/LogoutPage';
// import AuthRedirector from './components/AuthRedirector';
// import AuthContainer from './components/userfront/AuthContainer';
import AuthContainer from './components/auth/AuthContainer';
import BalanceForm from './components/custom/balance/BalanceForm';
import PasswordResetPage from './components/userfront/PasswordResetPage';
import WaitForConfirmation from './components/userfront/WaitForConfirmation';
import dayjs from 'dayjs';
import { usePushListener } from './hooks/usePushListener';
import { usePushStore } from './store/pushStore';
import NotFoundPage from './components/NotFoundPage';
import { useAuthStore } from './store/useAuthStore3';
import { GoogleAuthCallback } from './components/auth/AuthGoogleCallback';
import { SubtenantsList } from './components/custom/subtenants/SubtenantsList';
import { UserList } from './components/custom/users/UserList';

type RouteParams = {
  action: string;
};

const App: React.FC = () => {
  const { t, i18n } = useTranslation();

  usePushListener();

  const pending = usePushStore((s) => s.pending);

  useEffect(() => {
    console.log('pending:', pending);
  }, [pending]);

  useEffect(() => {
    // Устанавливаем локаль при загрузке и при каждой смене языка
    dayjs.locale(i18n.language);
  }, [i18n.language]);  

  const isAuthHydrated = useAuthStore(state => state.isHydrated);
  const authState = useAuthStore(state => state.authState);
  const isConfirmed = useAuthStore(state => state.isConfirmed);
  const { isLoading, isEmailConfirmed, hasRole: userHasRole, userName, lang, accessToken } = useAuthStore();
  useEffect(() => {
    if (lang) {
      console.log('lang changed:', lang);
      i18n.changeLanguage(lang || 'uk');
      dayjs.locale(lang || 'uk');
    }
  }, [lang]);

  if (!isAuthHydrated) {
    console.log('[App] Auth not hydrated');
    return (
      <Container sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Container>
    );
  }

  if (window.location.pathname === '/auth/google/callback') {
    console.log('[App] Google Auth Callback Route active');
    console.log('[App] authState:', authState, 'isConfirmed:', isConfirmed);
    return (
      <Routes>
        <Route path="/auth/google/callback" element={<GoogleAuthCallback />} />
        <Route path="/" element={<AuthContainer />} />
      </Routes>
    );
  }

  if (authState === 'AUTHORIZED' && !isConfirmed) {
    console.log("[App] authState:", authState, "isConfirmed:", isConfirmed);
    alert ('Please follow registration steps before accessing the app');
 // useAuthStore.setState({ authState: 'LOGIN' });
    useAuthStore.setState({ authState: 'NOT_REGISTERED' });
    return <AuthContainer />;
  }

  if (authState !== 'REGISTERED_AND_SET_UP' && authState !== 'AUTHORIZED') {
    console.log("[App] authState:", authState);
    return <AuthContainer />;
  }

  const isAuthenticated = !!accessToken;

  // todo: email confirmation
  // useEffect( ()=> {
  //   const urlParams = new URLSearchParams(window.location.search);
  //   const token = urlParams.get('token');
  //   const uuid = urlParams.get('uuid');
  //   if (token && uuid && !isLoading) {
  //     console.log('email confirmation'); 
  //   }
  // }, [isLoading]); 
  
  // useAxiosSetup();

  const appTitle = "LPR Application";

  const note = t('BalanceForm.PaidUntil');

  // спиннер показываем только для авторизованных иначе сбивается форма регистрации
  // if (isLoading && isAuthenticated && !isAuthHydrated) {
  //   console.log('[App] isLoading');
  //   return (
  //     <Container sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
  //       <CircularProgress />
  //     </Container>
  //   );  
  // }

  // 2. ПРОВЕРКА НА RESET (До проверки авторизации!)
  if (window.location.pathname === '/reset') {
    console.log('[App] PasswordResetPage');
    return <PasswordResetPage />;
  }

  // console.log("Check isAuthenticated:", isAuthenticated);
  // if (!isAuthenticated) {
  //   console.log('[App] !isAuthenticated');
  //   return <AuthContainer />;
  // }

  // if (!isAuthHydrated) {
  //   console.log('[App] !isAuthHydrated');
  //   return <CircularProgress />;
  // }

  // console.log("Check isConfirmed:", isConfirmed);
  // if (!isEmailConfirmed) {
  //   console.log('[App] !isEmailConfirmed');
  //   return <WaitForConfirmation />;
  // }

  //// if (!isConfirmed) {
  ////   console.log('[App] !isConfirmed');
  ////   return <WaitForConfirmation />;
  //// }

  // const isCustomerSetupNeeded = !customer || customer.customer_id === 0 || customer.customer_id === -1;
  // console.log("Check Customer:", customer?.customer_id, 'isCustomerSetupNeeded', isCustomerSetupNeeded);
  // if (isCustomerSetupNeeded) {
  //   return <CustomerSetup navigateTo='/points' />; 
  // }
  
  // console.log("APP_RENDER: auth:", isAuthenticated, "token_exists:", !!useAuthStore.getState().accessToken);

  console.log("Rendering Routes...");
  
  return (
    <div>
      <CssBaseline />

      <ResponsiveDrawer
        items={[
          { label: t('Drawer.home'), route: "/", icon: <HomeIcon /> },
          { label: t("Drawer.plates"), route: "/plates", icon: <DirectionsCarIcon /> },
          { label: t("Drawer.groups"), route: "/groups", icon: <GroupIcon /> },
          { label: t("Drawer.events"), route: "/events", icon: <HistoryIcon /> },
          { label: t("Drawer.StatisticReport"), route: "/statisticreport", icon: <AccountTree /> },
          ...(userHasRole('viewer')
            ? [ { label: t("Drawer.billing"), route: "/billing", icon: <Payment />, },
                { label: t("Drawer.points"), route: "/points", icon: <PlaceIcon /> },
                { label: t("Drawer.checkpoints"), route: "/checkpoints", icon: <RouteIcon /> },
                { label: t("Drawer.cameras"), route: "/origins", icon: <VideocamIcon /> },]
            : []
          ),
          {
            label: t("Drawer.setup"), icon: <SettingsIcon />, route: '', children: [
              { label: t("Drawer.mainSetup"), route: "/setup", icon: <SettingsApplications /> },
              { label: t("Drawer.reactions"), route: "/reactions", icon: <NotificationsActiveOutlinedIcon /> },
              ...(userHasRole('viewer')
                ? [{ label: t("Drawer.subtenants"), route: "/subtenants", icon: <CorporateFare />, }]
                : []),
              { label: t("Drawer.users"), route: "/users", icon: <PeopleIcon /> },
            ],
          },
          ...(userHasRole('admin') 
            ? [{ label: t("Drawer.customers"), route: "/customers", icon: <PeopleIcon /> }] 
            : []),
          ...(isAuthenticated 
            ? [{ label: t("Drawer.logout", {name: userName}), route: "/logout", icon: <LogoutIcon /> }] 
            : []),
        ]}
        title={appTitle}
        note={note}
      >
        
        {/* <AuthRedirector /> */}
        {/* <AuthContainer /> */}

        <Routes>

          <Route path="/reset" element={<PasswordResetPage />} />

          {/* Default/Home Route */}
          <Route path="/" element={<HomePage />} />
          <Route path="/dashboard" element={<HomePage />} />
          <Route path="/points" element={<PointsPage />} />
          <Route path="/checkpoints" element={<CheckPointsPage />} />
          <Route path="/origins" element={<OriginsPage />} />
          <Route path="/groups" element={<GroupsPage />} />
          <Route path="/plates" element={<PlatesPage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/events/:paramId" element={<EventsPage />} />
          <Route path="/statisticreport" element={<StatisticReportPage />} />
          <Route path="/setup" element={<SetupPage />} />
          <Route path="/reactions" element={<ReactionsPage />} />
          <Route path="/subtenants" element={<SubtenantsList />} />
          <Route path="/users" element={<UserList />} />
          <Route path="/billing" element={<BalanceForm />} />
          <Route path="/customers" element={<CustomersPage />} />
          <Route path="/logout" element={ <LogoutPage /> } />
          <Route path="/auth/google/callback" element={<GoogleAuthCallback />} />

          {/* <Route path="*" element={
            <Typography variant="h5" sx={{ p: 3 }}>
              404 - Page Not Found
            </Typography>
          } /> */}

          <Route 
              path="*" 
              element={
                isAuthenticated ? <SafeNotFound /> : null
              } 
            />
        </Routes>
      </ResponsiveDrawer>
      
      {import.meta.env.DEV && (
      <footer style={{ 
        position: 'fixed', 
        bottom: '10px', 
        right: '10px', 
        fontSize: '0.8rem', 
        color: '#666',
        background: 'rgba(255,255,255,0.9)', // чтобы читалось на любом фоне
        padding: '5px',
        pointerEvents: 'none', // чтобы сквозь него можно было кликать
        zIndex: 9999 
      }}>
        version: {__APP_VERSION__} | build: {__BUILD_TIME__}
      </footer>
      )}
    </div>
  );
};

const SafeNotFound = () => {
  const [isMounting, setIsMounting] = React.useState(true);

  React.useEffect(() => {
    // Даем роутеру 50мс, чтобы он переключился на нужный роут
    const timer = setTimeout(() => setIsMounting(false), 50);
    return () => clearTimeout(timer);
  }, []);

  if (isMounting) {
    return null; // Пока роутер в прыжке, не показываем ничего
  }

  return <NotFoundPage />;
};

export default App;
